// extracted by mini-css-extract-plugin
export default {"photoPost":"UserPhotoPost_photoPost__dyXcg","file":"UserPhotoPost_file__TXl-Z","preview":"UserPhotoPost_preview__j9uDZ"};